<template>
<div class="grid">

<div class="col-12">

<template v-if="is_exempted_from_audit">
<h3 class="text-green-600">Muafiyet belgeleri yeterli <i class="pi pi-check ml-2" style="font-size: 1.2em"></i></h3>	
</template>
</div>



<!-- exemption -->
<div class="col-12 " v-for="exemptioncertificate in exemptioncertificates">

<template v-if="exemptioncertificate.upload_status">
<h4 class="text-green-600">{{exemptioncertificate.certificatetype.name}} <i class="pi pi-check ml-2" style="font-size: 1.2em"></i></h4>	
</template>
<template v-else>
<h4 class="text-purple-600">{{exemptioncertificate.certificatetype.name}}</h4>	
</template>

<DataTable 
:value="exemptioncertificate.documents" 
responsiveLayout="scroll"
editMode="cell" 
@cell-edit-complete="onCellEditComplete"
>
  <Column field="certification_body" :header="$store.state.languages.lang_phrases.sertifika_tedarikcisi"></Column>

	<Column field="valid_through" :header="$store.state.languages.lang_phrases.gecerlilik_suresi">
	    <template #body="slotProps">
	        <p class="my-3">{{ $filters.momentFormat(slotProps.data.valid_through," Do-MM-YYYY ")}}</p>
	    </template>
	</Column>

	<Column field="valid_through" :header="$store.state.languages.lang_phrases.kalan_sure">
	    <template #body="slotProps">
	    	<template v-if="getValidDate(slotProps.data.valid_through)<0">
	    		<Tag 
						class="ml-2   custom-chip" 
						:value="$store.state.languages.lang_phrases.suresi_dolmus" 
						style="background-color:#dd4b39"
						/>
	    	</template>
	    	<template v-else>
	    		<p class="my-3" >{{ getValidDate(slotProps.data.valid_through)}} gün</p>
	    	</template>
	        
	    </template>
	</Column>

	<Column field="status" :header="$store.state.languages.lang_phrases.durum">
	    <template #body="slotProps">
	    	<Tag 
	    	v-if="slotProps.data.status=='uploaded'"
			class="mr-2 mt-1 custom-chip"  
			:value="this.$store.state.languages.lang_phrases.degerlendirmede" 
			style="background-color:#3b82f6"
			/>

			<Tag 
	    	v-if="slotProps.data.status=='rejected'"
			class="mr-2 mt-1 custom-chip"  
			:value="this.$store.state.languages.lang_phrases.gecersiz" 
			style="background-color:#a82400"
			/>

			<Tag 
	    	v-if="slotProps.data.status=='accepted'"
			class="mr-2 mt-1 custom-chip"  
			:value="this.$store.state.languages.lang_phrases.gecerli" 
			style="background-color:#4dc247"
			/>	       
	    </template>
	</Column>

	<Column field="rejection_note" :header="$store.state.languages.lang_phrases.red_sebebi" headerStyle="width: 12rem">
	    <template #body="slotProps">
	        {{slotProps.data.rejection_note}}
	    </template>
	    <template #editor="{ data, field }">
				<Textarea  v-model="data.rejection_note" autofocus rows="5" cols="30" autoResize  />
				</template>
	</Column>

	<Column field="answer" 
	header=""
	v-if="$store.state.auth.userroles.includes('admin') || $store.state.auth.userroles.includes('technical_auditor')"
	>
	    <template #body="slotProps">
	    	<template v-if="slotProps.data.status=='uploaded'">
	    		<Button :label="$store.state.languages.lang_phrases.onayla" class=" p-button-primary p-button-outlined  p-button-sm" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
	    		<Button :label="$store.state.languages.lang_phrases.reddet" class=" p-button-danger p-button-outlined  p-button-sm ml-2" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
	    	</template>

	    	<template v-if="slotProps.data.status=='rejected'">
	    		<Button :label="$store.state.languages.lang_phrases.onayla" class=" p-button-primary p-button-outlined  p-button-sm" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
	    	</template>

	    	<template v-if="slotProps.data.status=='accepted'">
	    		<Button :label="$store.state.languages.lang_phrases.reddet" class=" p-button-danger p-button-outlined  p-button-sm ml-2" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
	    	</template>       
	    </template>
	</Column>

	<Column field="filepath" :header="$store.state.languages.lang_phrases.yuklenen_dosyalar">
	    <template #body="slotProps">
	        <a :href="apihook+slotProps.data.filepath"  target="_blank"><i class="pi pi-eye" style="font-size: 1.6em"></i></a>
	    </template>
	</Column>



</DataTable>

</div>
<!-- exemption -->










<CertificateRejectionModal @rejected="submitRejectDocument" ref="certmodal">


</CertificateRejectionModal>





</div>
</template>

<script>
import moment from "moment";
import CertificateRejectionModal from "./CertificateRejectionModal"
export default {

  name: 'SupplierProjectFlowSummaryForAudit',
  props:["flowsupplier","exemptioncertificates","requiredcertificates"],
  data () {
    return {
    	submitting:false,
    }
  },
  components:{CertificateRejectionModal},
  computed:{
  	apihook()
  	{
  		let api =  process.env.VUE_APP_API_HOOK
  		api = api.replace("/api/","/")
  		return "https://storage.googleapis.com/verifycloud/"
  	},
  	is_exempted_from_audit()
  	{
  		let is_exempted_from_audit = 0
  		for (let i = 0; i < this.exemptioncertificates.length; i++)
			{
				let is_document_exempted = 0
				for (let ii = 0; ii < this.exemptioncertificates[i].documents.length; ii++)
				{
				  if(this.exemptioncertificates[i].documents[ii].status=="accepted" )
				  {
				    is_document_exempted = 1  
				    break          
				  }
				  else
				  {
				  	is_document_exempted = 0 
				  }
				}

				if(is_document_exempted)
				{
					is_exempted_from_audit = 1
				}
				else
				{
					is_exempted_from_audit = 0
					break
				}
			}
		

		return is_exempted_from_audit

  	},

  	is_audit_documents_uploaded()
  	{
  		let is_exempted_from_audit = 0
  		for (let i = 0; i < this.requiredcertificates.length; i++)
			{
				let is_document_exempted = 0
				for (let ii = 0; ii < this.requiredcertificates[i].documents.length; ii++)
				{
				  if(this.requiredcertificates[i].documents[ii].status=="accepted" )
				  {
				    is_document_exempted = 1  
				    break          
				  }
				  else
				  {
				  	is_document_exempted = 0 
				  }
				}

				if(is_document_exempted)
				{
					is_exempted_from_audit = 1
				}
				else
				{
					is_exempted_from_audit = 0
					break
				}
			}	
		return is_exempted_from_audit
  	},
  	
  },
  methods:{
  	onCellEditComplete(data)
  	{
  		console.log(data)
  		//update_uploaded_doc_rejection_note
  		let formdata = new FormData() 
  		formdata.append("rejection_note",data.newData.rejection_note) 
  		this.generalSubmission(formdata,"audit/update_uploaded_doc_rejection_note/"+data.newData.id,this.afterAction)
  	},

  	getValidDate(data)
  	{
  		
  		if(data)
  		{
  			let today = moment()
  			let date = moment(data)
  			let diff = date.diff(today, 'days')
  			return diff
  		}
  		return 0
  	},
  	acceptDocument(id)
  	{
  		console.log(id)
  		//return false
  		this.submitting = true
  		let formdata = new FormData()  		
  		this.generalSubmission(formdata,"audit/accept_uploaded_document/"+id,this.afterAction)
  	},
  	rejectDocument(id)
  	{
  		this.$refs.certmodal.showModal(id)
  	},
  	submitRejectDocument(data)
  	{
  		console.log(data)  		 
  		this.submitting = true
  		let formdata = new FormData() 
  		formdata.append("rejection_note",data.rejection_note) 
  		this.generalSubmission(formdata,"audit/reject_uploaded_document/"+data.id,this.afterAction)
  	},
  	afterAction(response)
  	{
  		this.submitting = false
  		this.$emit("documentUpdated",response.data)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>